// extracted by mini-css-extract-plugin
export default {"data":"list_data__yiFwd","data_details":"list_data_details__3wMFL"};